<template>
  <div
    :class="
      'base-create ' + (isDisabledComponent ? 'create-class-com-disable' : '')
    "
  >
    <div class="base-create-header">
      <h1>
        <span class="circle-step">2</span>
        <span>
          {{ title }}
        </span>
      </h1>
    </div>
    <div class="base-create-body">
      <create-class-goals
        :goals.sync="goals"
        @goal-updated="changeGoal"
        :organizationType="currentOrganizationType"
      />
    </div>
  </div>
</template>

<script>
import CreateClassGoals from "@/components/classes/create-classes/CreateClassGoals";
import { mapGetters, mapActions } from "vuex";
import { pathOr } from "ramda";
import { addDays } from "date-fns";

export default {
  components: {
    CreateClassGoals,
  },
  data() {
    return {
      goals: {
        daysPractice: 5,
        minutesPractice: 15,
        engagementFirstDate: "",
        engagementSecondDate: "",
      },
    };
  },
  created() {
    this.goals.daysPractice = pathOr(5, ["daysPractice"])(this.buildingClass);
    this.goals.minutesPractice = pathOr(15, ["minutesPractice"])(
      this.buildingClass
    );

    this.goals.engagementFirstDate = pathOr(this.buildingClass['startDate'] ? addDays(this.buildingClass['startDate'], 7) : "", ['engagementFirstDate'])(this.buildingClass)

    this.goals.engagementSecondDate = pathOr(this.buildingClass["endDate"], [
      "engagementSecondDate",
    ])(this.buildingClass);
  },
  computed: {
    ...mapGetters({
      currentOrganizationType: "organization/currentOrganizationType",
      class: "classes/getBuildingClass",
    }),
    title() {
      // const prefix = !this.editMode ? `${this.currentStep}.` : ''
      return `${this.$t(
        this.$i18nLabelsHelper(
          this.currentOrganizationType,
          "goals.engage_students"
        )
      )}`;
    },
    isDisabledComponent() {
      return this.currentStep > this.componentStep && this.editMode == false;
    },
    buildingClass() {
      return this.class;
    },
  },
  props: {
    editMode: {
      type: Boolean,
      default: false,
    },
    currentStep: {
      type: Number,
      default: 3,
    },
    componentStep: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    changeGoal() {
      if (this.editMode) {
        this.updateBuildingClass(this.goals);
      }
    },
    setGoals() {
      this.updateBuildingClass(this.goals);
      this.$emit("next-step", this.currentStep);
    },
    ...mapActions({
      updateBuildingClass: "classes/updateBuildingClass",
    }),
    onUpdateReady() {
      this.goals.daysPractice = pathOr(5, ["daysPractice"])(this.buildingClass);
      this.goals.minutesPractice = pathOr(15, ["minutesPractice"])(
        this.buildingClass
      );

      this.goals.engagementFirstDate = pathOr(this.buildingClass['startDate'] ? addDays(this.buildingClass['startDate'], 7) : "", ['engagementFirstDate'])(this.buildingClass)
      this.goals.engagementSecondDate = pathOr(this.buildingClass["endDate"], [
        "engagementSecondDate",
      ])(this.buildingClass);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../scss/_colors.scss";
p {
  font-weight: 300;
  font-size: 18px;
  color: $dark-blue-2;
  margin: 0;
}
.practice {
  display: flex;
  align-items: center;
  margin-top: 44px;
  .input-wrapper {
    display: flex;
    align-items: center;
    font-weight: 600;
    font-size: 14px;
    color: $black;
    .elsa-input {
      width: 36px;
      margin: 0 8px;

      &.minutes-practice {
        width: 58px;
      }

      &::v-deep .el-input .el-input__inner {
        height: 32px;
        text-indent: 8px;
      }
    }
  }
  .description {
    margin-left: 16px;
    p {
      margin-top: 5px;
      font-size: 14px;
    }
  }
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    align-items: start;
    .description {
      margin-top: 15px;
      margin-left: 0;
    }
    .input-wrapper {
      flex-direction: column;
      align-items: start;
      .elsa-input {
        margin: 5px 0;
      }
    }
  }
}

.el-row {
  flex-wrap: wrap;
}

.engagement {
  margin-top: 52px;
  .elsa-section {
    padding: 0;
  }
  &.no-padding {
    margin-top: 0;
  }
}

.el-form {
  padding-bottom: 0;
}
</style>
